// extracted by mini-css-extract-plugin
module.exports = {"footer":"site-footer-module--footer--23WXR","footerLink":"site-footer-module--footer-link--3S0jV"};